<template>
    <div>
        <Head title="Claim Challenge" />

        <heading>
            <template #heading>
                <span class="capitalize">Claim Challenge</span>
            </template>
        </heading>

        <div class="mx-auto px-4 max-w-3xl sm:mt-5 sm:px-6 lg:max-w-7xl">
            <!-- This example requires Tailwind CSS v2.0+ -->
            <nav aria-label="Progress">
                <ol class="border border-gray-300 rounded-md divide-gray-300 divide-y md:flex md:divide-y-0">
                    <li class="relative md:flex md:flex-1">
                        <!-- Completed Step -->
                        <a href="#" class="group flex items-center w-full">
                            <span class="flex items-center px-6 py-4 text-sm font-medium">
                                <span class="flex flex-shrink-0 items-center justify-center w-10 h-10 bg-indigo-600 group-hover:bg-indigo-800 rounded-full">
                                    <!-- Heroicon name: solid/check -->
                                    <svg class="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </span>
                                <span class="ml-4 text-gray-900 text-sm font-medium">Terms & Conditions</span>
                            </span>
                        </a>

                        <!-- Arrow separator for lg screens and up -->
                        <div class="absolute right-0 top-0 hidden w-5 h-full md:block" aria-hidden="true">
                            <svg class="w-full h-full text-gray-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
                                <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </li>

                    <li class="relative md:flex md:flex-1">
                        <!-- Current Step -->
                        <a href="#" class="flex items-center px-6 py-4 text-sm font-medium" aria-current="step">
                            <span class="flex flex-shrink-0 items-center justify-center w-10 h-10 border-2 border-indigo-600 rounded-full">
                                <span class="text-indigo-600">02</span>
                            </span>
                            <span class="ml-4 text-indigo-600 text-sm font-medium">Age</span>
                        </a>

                        <!-- Arrow separator for lg screens and up -->
                        <div class="absolute right-0 top-0 hidden w-5 h-full md:block" aria-hidden="true">
                            <svg class="w-full h-full text-gray-300" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
                                <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </li>

                    <li class="relative md:flex md:flex-1">
                        <!-- Upcoming Step -->
                        <a href="#" class="group flex items-center">
                            <span class="flex items-center px-6 py-4 text-sm font-medium">
                                <span class="flex flex-shrink-0 items-center justify-center w-10 h-10 border-2 border-gray-300 group-hover:border-gray-400 rounded-full">
                                    <span class="text-gray-500 group-hover:text-gray-900">03</span>
                                </span>
                                <span class="ml-4 text-gray-500 group-hover:text-gray-900 text-sm font-medium">Upload Video</span>
                            </span>
                        </a>
                    </li>
                </ol>
            </nav>
        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout"
import Heading from "@/Components/Heading"

export default {
    components: { Heading },
    layout: AppLayout,
}
</script>
